import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import 'firebase/firestore';


Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    layout: "home-layout",
    user: {
      id: ""
    },
    addUserStatus: false
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
      state.addUserStatus = true;
    },
    SET_LAYOUT(state, payload) {
      state.layout = payload;
    }
  },
  getters: {
    user: state => {
      return state.user;
    },
    layout(state) {
      return state.layout;
    }
  },
  actions: {
    singUserUp({ commit }, payload) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.correo, payload.contrasena)
        .then(result => {
          const newUser = {
            id: result.user.uid
          };
          console.log(result.user.email);
          let typeU = payload.selectedTypeUser
          let finalType = ""
          if (typeU == "4bits"){
            finalType = "0"
          }
          else if (typeU == "Administrador"){
            finalType = "1"
          }
          else if (typeU == "Cocina"){
            finalType = "2"
          }
          else {
            finalType = "3"
          }
          result.user.updateProfile({
              displayName:
              finalType +  
              "/" +
                payload.nombre +
                "/" +
                payload.apellidos
            })
            .then(function() {
              console.log("datos guardados con exito.");
            })
            .catch(function(error) {
              console.log("error al guardar datos.");
              console.log("errorCode: " + error.code);
              console.log("errorMessage: " + error.message);
            });
          commit("setUser", newUser);
        })
        .catch(error => {
          alert(error.message);
          this.state.addUserStatus = false;
        });
    }
  }
});
